module.exports = __webpack_public_path__ + "img/figma-logo.48284fdd.svg";